/* eslint-disable */
export default {
  header: 'Disattiva il tracciamento degli errori',
  content:
    'La disattivazione della modalità di tracciamento errori cancellerà tutti gli eventuali registri errori correnti. Continuare?',
  confirm: 'Disattiva',
  cancel: 'Annulla',
} as const;

// @key: @#@"header"@#@ @source: @#@"Turn off error tracking"@#@
// @key: @#@"content"@#@ @source: @#@"Turning off error tracking mode will delete any current error logs. Do you wish to continue?"@#@
// @key: @#@"confirm"@#@ @source: @#@"Turn off"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
